import { render, staticRenderFns } from "./PageCreatorDashboard.vue?vue&type=template&id=0c6352b2"
import script from "./PageCreatorDashboard.vue?vue&type=script&lang=js"
export * from "./PageCreatorDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports